<template>
  <ModalControl
    @closed="$emit('closed')"
    :show="show"
    v-bind:title="lang('lbl_0000135')"
    dismiss
  >
    <div class="text-sm text-justify p-2 leading-relaxed">
      <p class="pb-4">
        By participating in this Fun Run event, you consent to PAFCPIC's data
        privacy policy in compliance with the Data Privacy Act of 2012.
      </p>
      <p class="pb-4">
        PAFCPIC will be covering the event by capturing photos and videos which
        may be posted in all of PAFCPIC's communication channels including its
        Social Media accounts, Website, Newsletter, Annual Reports, and other
        in-house or external publishing partners.
      </p>
      <p class="pb-4">
        To read more about PAFCPIC's Data Privacy Policy, you may visit this
        link:
        <strong>
          <a
            href="https://pafcpic.ph/privacy-policy"
            target="_blank"
            class="text-primary underline hover:text-primary-dark"
          >
            https://pafcpic.ph/privacy-policy
          </a>
        </strong>
      </p>

      <!-- Centered image -->
      <div class="flex justify-center mt-2">
        <img :src="this.getNPCLogo()" class="w-24" />
      </div>
    </div>

    <div class="flex flex-col">
      <ButtonControl class="mt-4" @click="agree">
        {{ lang("lbl_0000302") }}
      </ButtonControl>
    </div>
  </ModalControl>
</template>

<script>
import ModalControl from "./ModalControl.vue";
import ButtonControl from "./ButtonControl.vue";
import mixin from "./../../mixin.js";

export default {
  name: "v-eft-terms-control",
  mixins: [mixin],
  emits: [
    "success",
    "error",
    "alert",
    "login",
    "logout",
    "showloader",
    "hideloader",
    "showblinder",
    "hideblinder",
    "terminate",
    "checkauth",
    "nofooter",
    "shownavbar",
    "hidenavbar",
    "opensidebar",
    "closed",
    "agreed",
  ],
  components: {
    ModalControl,
    ButtonControl,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    agree() {
      this.$emit("agreed");
    },
    getNPCLogo() {
      const path = "funrun/";
      const file_name = "npc_seal.png";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
  },
};
</script>
